module.exports = __webpack_public_path__ + "static/media/user-solid.e732f861.svg";